/**
 * Valour Fits - Free Shipping Component (Items Based)
 */
class FreeShippingComponent extends HTMLElement {
  constructor() {
    super();
  }

  // 設定免運目標件數
  static targetItems = 2;

  connectedCallback() {
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

    // 監聽主題購物車的所有即時更新廣播
    document.addEventListener('cart:updated', () => this.initialize());
    document.addEventListener('cart:refresh', () => this.initialize());
    document.addEventListener('cart-update', () => this.initialize());

    this.initialize();
  }

  initialize() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.calculateProgress(cart);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  calculateProgress(cart) {
    const currentItemCount = cart.item_count || 0;

    // 計算百分比：0件=0%，1件=50%，2件=100%
    let freeShipBar = Math.round((currentItemCount / FreeShippingComponent.targetItems) * 100);
    if (freeShipBar >= 100) {
      freeShipBar = 100;
    }

    const text = this.getText(currentItemCount);
    this.setProgressWidthAndText(freeShipBar, text);
  }

  getText(currentItemCount) {
    let text = '';
    if (currentItemCount === 0) {
      text = '<span>🚚【港澳限時免運】任選 <strong>' + FreeShippingComponent.targetItems + ' 件</strong> 即享順豐包郵直送！</span>';
    } else if (currentItemCount >= FreeShippingComponent.targetItems) {
      text = '<span>🎉 太正喇！你已享有 <strong>順豐包郵</strong> 優惠！</span>';
    } else {
      const remainingItems = FreeShippingComponent.targetItems - currentItemCount;
      text = '<span>🔥 仲差 <strong>' + remainingItems + ' 件</strong> 即享順豐包郵直送！</span>';
    }
    return text;
  }

  setProgressWidthAndText(freeShipBar, text) {
    // 延時確保 DOM 與抽屜動畫準備就緒
    setTimeout(() => {
      if (this.progressMeter) {
        this.progressMeter.style.width = `${freeShipBar}%`;
      }
      if (this.messageElement) {
        this.messageElement.innerHTML = text;
      }
    }, 100);
  }
}

// 註冊組件
if (!customElements.get('free-shipping-component')) {
  customElements.define('free-shipping-component', FreeShippingComponent);
}